// Broadcast channel for cross-tab communication
export const PERMISSION_CHANNEL = 'asf-panel-permissions';

export interface PermissionUpdateMessage {
  type: 'PERMISSION_UPDATE';
  userId: string;
  timestamp: number;
}

export class PermissionBroadcaster {
  private channel: BroadcastChannel | null = null;

  constructor() {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel(PERMISSION_CHANNEL);
    }
  }

  sendPermissionUpdate(userId: string) {
    if (this.channel) {
      const message: PermissionUpdateMessage = {
        type: 'PERMISSION_UPDATE',
        userId,
        timestamp: Date.now(),
      };
      this.channel.postMessage(message);
    }
  }

  onPermissionUpdate(callback: (message: PermissionUpdateMessage) => void) {
    if (this.channel) {
      this.channel.onmessage = (event) => {
        if (event.data && event.data.type === 'PERMISSION_UPDATE') {
          callback(event.data);
        }
      };
    }
  }

  close() {
    if (this.channel) {
      this.channel.close();
    }
  }
}

export const permissionBroadcaster = new PermissionBroadcaster();